import { useSearchParams, Navigate, useNavigate } from 'react-router-dom';
import { Text } from '@chakra-ui/react';

import Page from 'app/pages/Page';
import TabbedSignup from 'app/components/auth/TabbedSignup';
import useAuthStore from 'app/stores/auth';

const SignUp = () => {
  const authenticated = useAuthStore((state) => !!state.token);

  const navigate = useNavigate();
  const [search] = useSearchParams();
  const provider = search.has('provider');
  const redirect =
    search.get('redirect') || provider ? '/dashboard' : '/workbook';

  return (
    <Page title="Sign Up" panelWidth="32em">
      {authenticated && <Navigate to={redirect} />}
      <Text
        fontSize="4xl"
        fontWeight="bold"
        fontFamily="DM Serif Text, serif"
        mb={4}
      >
        Sign Up
      </Text>
      <TabbedSignup
        isProvider={provider}
        onClickTab={(isProvider: boolean) =>
          navigate({
            pathname: '/signup',
            search: isProvider ? '?provider' : '',
          })
        }
        onClickLogin={(isProvider: boolean) =>
          navigate({
            pathname: '/login',
            search: isProvider ? '?provider' : '',
          })
        }
      />
    </Page>
  );
};

export default SignUp;
